import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout';
import Home from './pages/home';
import Blog from './pages/blog';
import BlogView from './pages/blogView';
import About from './pages/about';
import Projects from './pages/projects';
import ProjectView from './pages/projectView';
import Contact from './pages/contact';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/*
          1) Define a parent route using `Layout` as the element.
          2) All child routes will share the layout (Header + Footer).
        */}
        <Route path="/" element={<Layout />}>
          {/* Child routes */}
          <Route index element={<Home />} /> 
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:id" element={<BlogView />} />

          <Route path="projects" element={<Projects />} />
          <Route path="projects/:id" element={<ProjectView />} />

          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />

        </Route>
      </Routes>
    </Router>
  );
};

export default App;
